import { SUPPORTED_LANGUAGES, type SupportedLanguage } from "../i18n";

/**
 * Extract locale from a URL path like /es/faq -> "es", /faq -> "en", / -> "en"
 */
export function getLocaleFromPath(pathname: string): SupportedLanguage {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length > 0) {
    const first = segments[0] as SupportedLanguage;
    if ((SUPPORTED_LANGUAGES as readonly string[]).includes(first) && first !== "en") {
      return first;
    }
  }
  return "en";
}

/**
 * Strip locale prefix from path: /es/faq -> /faq, /es/ -> /, /faq -> /faq
 */
export function stripLocaleFromPath(pathname: string): string {
  const locale = getLocaleFromPath(pathname);
  if (locale === "en") return pathname;
  const stripped = pathname.replace(new RegExp(`^/${locale}(/|$)`), "/");
  return stripped || "/";
}

/**
 * Build a locale-prefixed path: ("es", "/faq") -> "/es/faq", ("en", "/faq") -> "/faq"
 */
export function buildLocalePath(locale: SupportedLanguage, basePath: string): string {
  const clean = basePath === "/" ? "" : basePath;
  if (locale === "en") return basePath;
  return `/${locale}${clean}`;
}
